import { PaymentType } from '@domgen/dgx-fe-common';
import { CheckoutCardPaymentDetails } from '../../models/checkout-payment/checkout-card-payment-details.interface';

export const mockCheckoutCardPaymentDetails: CheckoutCardPaymentDetails = {
  paymentType: PaymentType.Card,
  cardPaymentReference: 'cardPaymentReference',
};
